import { Nullable } from '@/shared/types/app.types'

export interface LocalCasesTypesModalBasicFormComboCaseTypesSelected {
    value: number
    text: string
}

export interface LocalCasesTypesModalBasicFormComboCaseTypes {
    list: LocalCasesTypesModalBasicFormComboCaseTypesSelected[]
    selected: Nullable<LocalCasesTypesModalBasicFormComboCaseTypesSelected>
}

export interface LocalCasesTypesModalBasicForm {
    caseTypes: LocalCasesTypesModalBasicFormComboCaseTypes
}
export const initialLocalCasesTypesModalBasicFormState =
    (): LocalCasesTypesModalBasicForm => ({
        caseTypes: {
            list: [],
            selected: null
        }
    })
